//Japanese
export default  {
    homeScreen : {
        startConversation: 'チャットを始める',
        newConversationButton: '新しいチャット',
        newMessageButton: '+ 新しいメッセージ',
        allTopics: 'すべてのトピック',

        allChatsButton: '全て見る',
        poweredBy: '提供 Richpanel',
        reOpenConversation: 'チャットを開ける',
        recentConversations: 'チャット',
        startAChat: 'チャットを始める  ',
        noRecentConversations: 'チャットがありません',
        noRecentOrders: '注文がありません', 
        haveAQuestion: "質問もご意見も何でもお聞かせください",
        conversationClosed: `"チャットが終了しました。 この問題に対して質問がある場合にはチャットを再び開いてください。"`,
        retry: 'リトライ',
        errorOccured: 'リクエスト処理中にエラーが発生しました',
        successMessage: 'リスエストを受け付けました。{email}にてご連絡します',
        loadingMessage: 'リクエストを送信します。しばらくお待ちください',
        goHome: 'OK',
        sendUsMessage: '私達にメッセージを送ります',
        endChat: 'チャットを終了する',
        goto: 'に移動',
    },
    orderStatuses: {
        'completed': 'Completed',
        'pending': 'Pending',
        'on hold': 'On hold',
        'processing': 'Processing',
        'cancelled': 'Cancelled',
        'fulfilled': 'Fulfilled',
        'confirmed': 'Confirmed',
    },

    loginScreen: {
        title: 'ヘルプセンターにログイン',
        titleForOrdersScreenForward: 'ログインしてオーダーを見る',
        userIdFieldTitle: "電話番号またはEメール",
        userIdFieldPlaceHolder: "電話番号/Eメールを入力",
        sendCode: "入る",
        enterCode: '送信したコードを入力してください',
        enterTheCode: 'コードを入力',
        notYourUserId: '{userIdType}ではありませんか',
        userIdTypes: {
            'phone': 'ナンバー',
            'email': 'Eメール',
        },
        change: '変更',
        notReceivedCode: "コードを受信できない",
        resendCode: '再送信',
        in: "in",
        verifyCode: '認証',
        logout: 'ログアウト',
        orderNumberFieldTitle: 'あなたの注文番号',
        orderNumberFieldPlaceholder: '注文番号を入力 例: 1234',
        zipcodeFieldTitle: '配送ピンコード',
        zipcodeFieldPlaceholder: 'ピンコードを入力',
        emailFieldTitle: 'Eメール',
        emailFieldPlaceholder: 'Eメールを入力',
    },

    orderList : {
        reorder: '再注文',
        getHelp: 'ヘルプ',
        startNewConversation: '+ 新しいチャットを始める',
        viewPreviousOrder:'全ての注文を見る',
        seeAll: '全て見る',
        viewMoreOrders: 'さらに注文を見る',
        viewOrderStatus: '注文状況を見る',
        chatWithUs: 'チャットする',
        issueWithPreviousOrder:'過去の注文について' ,
        orderLabel: '注文',
        help: 'ヘルプ',
        lastOrder: '最も最近の注文',
        selectRelevantItems: '関連製品を選択',
        selectItemsErrorMsg: '製品を選択して進む',
        selectAll: '全て選択',
        selectQuantity: '製品数は？',
        helpWithThisOrder: 'この注文に関するヘルプ',
        yourOrders: 'あなたの注文',
        view: '見る',
        track: '追跡',
        addressTitle: '概要',
        billingAddressTitle: '請求先住所',
        shippingAddressTitle: '配送先住所',
        receiptTitle: '製品',
        itemTotal: '製品合計',
        taxes: '税',
        discounts: '割引', 
        giftCard: 'ギフトカード', 
        deliveryCharges: '配送料',
        total: '税',
        loginToViewOrders: '既存のお客様',
        loginSuggestion: "サポートを受ける",
        trackingOrderLabel: '注文の追跡',
        shipmentDescription: "配送について改めてご確認ください",
        free: "手数料",
        selectedItems: "製品を選択",
        items: "製品",
        "orderSearchPlaceholder": '注文によるフィルタリング #',
        "noOrderFound": '一致する注文はありません {orderId}',
    },
    chatListScreen: {
        header: 'あなたのチャット',
    },
    sentences: {
        "IN_A_DAY" : "1日を目安に返信します.",
        "IN_FEW_MINUTES": "数分を目安に返信します",
        "IN_FEW_HOURS": "数時間を目安に返信します",
        "AS_SOON_AS_THEY_CAN": "しばらくお待ちください",
        "BACK_ON": "戻ります",
        "BACK_IN": "戻ります",
        "HOURS": "時間",
        "MINUTES": '分',
        provideBelowDetails: "以下の詳細を入力してください",
    },
    inputFields: {
        submitted: '送信しました'
    },
    inputPropDisplayNames: {
        "email": "Eメール",
        "phone": "電話",
        "Phone": "電話",
        "firstName": "姓",
        "lastName": "名",
        "uid": "ユーザーID",
        "campaign": "UTMキャンペーン", 
        "medium": "UTMミディアム", 
        "googleplus": "Google plus", 
        "shippingPhone": "配送先電話番号",
        "source": "UTMソース", 
        "lastOrderAt": "最後の注文時間",
        "firstOrderAt": "最初の注文時間",
        "visits": "セッション",
        "facebook": "Facebook", 
        "twitter": "Twitter", 
        "updatedAt": "最後に見た",
        "createdAt": "最初に見た",
        "linkedin": "Linkedin", 
        "instagram": "Instagram", 
        "pinterest": "Pinterest",  
        "tumblr": "Tumblr", 
        "billingEmail": "請求先Eメール",
        "billingPhone": "請求先電話番号",
        "shippingEmail": "配送先Eメール",
        "state": "都道府県",
        "city": "市区町村",
        "country": "国",
        "deviceType": "デバイス",
        "browserName": "ブラウザー",
        "osName": "Os名",
        "platform": "プラットフォーム",
        "ltv": "CLV", 
        "ordersCount": "注文すう", 
        "name": "名前", 
        "RichpanelPredictedCLV": "予想CLV", 
        "RichpanelAliveProbability": "購入確率",
        "RichpanelNextOrderDate": "次の注文日",
        "RichpanelPredictedOrderCount": "予想注文数",
        "aov": "AOV", 
        "WebsiteURL":"ウェブサイトURL"
    },
    botMessages: {
        EXISITING_CUSTOMER: '既存のお客様ですか？',
        YES_EXISITING_CUSTOMER: "はい、既存の顧客です",
        NO_EXISITING_CUSTOMER: "いいえ、顧客ではありません",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "チームの連絡方法を選択してください",
        YOU_WILL_BE_NOTIFIED_EMAIL: "返信があったらこちらとEメールにてお知らせを受けます",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "返信があったらこちらで連絡を受けます",
        LEAVE_YOUR_MESSAGE: "メッセージを残してください",
        TEAM_WILL_BE_BACK_IN:"{hours}時間で戻ります",
        TEAM_WILL_BE_BACK_ON:"{availableAt}に戻ります",
        FEW_MORE_DETAILS: "ありがとうございます！もういくつかの情報で担当者にお繋ぎ致します",
    },
    initialForm: {
        heading: 'あなたの情報を入力しチャットを開始してください',
        startChat: 'チャットを始める'
    },
    customerJourneyPreChatForm: {
        heading: 'チャットを開始する',
        startChat: 'チャットを開始する',
        proceed: '進める',
        canWeHelpWithAnythingElse: '他にご用件はありますか？', 
        yes: 'yes',
        no: 'no',
        noThanks: "大丈夫です",
        yesContactSupport: "サポートとチャットする",
        contactSupport: "サポートに連絡する",
    },
    rating: {
        askedHeader: 'チャットを評価する',
        successHeader: 'チャットを評価しました',
        thanksMessage: "ありがとうございます",
        placeholderForRatingFeedback: "フィードバックはこちら"
    },
    placeholders: {
        emojiSearch: '絵文字を検索',
        typeAMessage: 'メッセージを入力',
        searchGifs: 'GIFを検索',
    },
    lastMessageText: {
        sentAGif: 'GIFを送る',
        sharedFile: 'ファイルを共有する',
        askedForQualificationDetails: '認証情報を聞きました',
        askedForRating: '評価を聞きました',
        askedForFeedback: 'フィードバックを聞きました',
        sharedOrderSummary: "注文サマリーを共有しました"
    },
    greetingAnimation: {
        weAreOnline: 'オンラインです',
        askUsAnything: '何でもお聞きください',
        chatWithUs: 'チャットする'
    },
    errorMessages: {
        enterEmailOrPhone:  "メール/電話を入力してください",
        enterValidOrPhone: "有効なメールアドレス/電話番号を入力してください",
        userNotFound: "この電話/メールのアカウントが見つかりませんでした",
        enterCode: 'ログインコードを入力してください',
        invalidCode: '無効なコード'
    }
}